import {Injectable} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmationDialogComponent} from '../components/confirmation-dialog/confirmation-dialog.component';

@Injectable()
export class ModalService {

  constructor(public modal: NgbModal) {
  }

  private modalRef: NgbModalRef;

  /**
   * Öffnet ein Modal als Bestätigungsdialog
   *
   * @param messages im Format [title, message]
   * @param buttonMessages im Format [buttonTextBestätigung, buttonTextAbbrechen]
   * @param successCallBack
   */
  openConfirmation(messages: Array<string>, buttonMessages: Array<string>, successCallBack: Function) {
    this.confirm(messages, buttonMessages).then(confirmed => {
      if (confirmed) {
        successCallBack();
      }
    }).catch(err => console.log(err));
  }

  confirm(messages: string[], buttonMessages: string[]) {
    const modalRef = this.modal.open(ConfirmationDialogComponent);
    modalRef.componentInstance.setMessages(messages);
    modalRef.componentInstance.setButtonMessages(buttonMessages);
    return modalRef.result;
  }

  /**
   * Öffnet ein Komponent im Modal und gibt die Referenz auf die geöffnete Komponente zurück
   *
   * @param component
   * @returns T
   */
  openComponent(component: any, options?: any): any {
    this.modalRef = this.modal.open(component, options);
    return this.modalRef.componentInstance;
  }

  /**
   * Verarbeitet das aktive Modal mit der übergebenen CallBack-Funktion
   *
   * @param callBack
   */
  handle(callBack: Function) {
    if (this.modalRef !== undefined) {
      this.modalRef.result.then(result => callBack(result)).catch(err => console.log(err));
    } else {
      throw new Error('Es ist kein aktives Modal vorhanden, das verarbeitet werden könnte!');
    }
  }

  openModal(component: any, options?: any) {
    return this.modal.open(component, options);
  }
}
